import styled from 'styled-components';
import { colors, getTypographyFontStyle, device } from '../../styles/global.style';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => {
    switch ($align) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  }};
  text-align: ${({ $align }) => $align || 'center'};
  padding: 24px 0;

  @media ${device.md} {
    padding: 40px 0;
  }
`;

const AccentLine = styled.div`
  width: 60px;
  height: 4px;
  background: ${colors.solarGradient};
  border-radius: 2px;
  margin-bottom: 20px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: -12px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background: ${colors.primary};
    border-radius: 50%;
    box-shadow: 0 0 10px ${colors.primary};
  }

  @media ${device.md} {
    width: 80px;
    height: 5px;
    margin-bottom: 24px;
  }
`;

const Subtitle = styled.p`
  ${getTypographyFontStyle({ variant: 'body1', weight: 400 })};
  color: ${({ color }) => color || colors.darkGrey};
  margin-top: 12px;
  max-width: 600px;
  line-height: 1.7;
  opacity: 0.85;

  @media ${device.md} {
    margin-top: 16px;
  }
`;

export { HeaderContainer, AccentLine, Subtitle };
